module.exports = __webpack_public_path__ + "static/media/clear-sky-night.a3f3f38d.svg";